<template>
  <el-container style='width: 100%;'>
    <el-header style='line-height: 80px;height: 80px;' align='center'>
      <span style='float:left;padding-left: 10px;'>角色信息</span>
      <el-button style='float:right;margin-top: 20px;margin-right: 10px;' type='success'
                 icon='el-icon-circle-plus-outline' @click='handleAddClick'>新增角色
      </el-button>
    </el-header>
    <el-main style='padding: 0px 20px; '>
      <el-table

        :data='tableData' v-loading='loading' stripe
                :default-sort="{prop: 'date', order: 'descending'}">
        <el-table-column type='index' label='序号' width='100'></el-table-column>
        <el-table-column prop='role_name' label='角色名称'></el-table-column>

<!--        <el-table-column prop='get_permission_value' label='获取权限值'></el-table-column>-->
<!--        <el-table-column prop='set_permission_value' label='设置权限值'></el-table-column>-->
<!--        <el-table-column prop='other_permission_value' label='其它权限值'></el-table-column>-->

        <el-table-column label='设置' width='180'>
          <template slot-scope='scope'>
            <el-button size='mini' type='success' @click='handleSettingClick(scope.row)'>编辑角色</el-button>
            <el-button size='mini' type='danger' @click='handleDeleteClick(scope.row)'>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-dialog :title='Tip' :visible.sync='dialogVisible' width='70%'>
      <el-form :label-position='labelPosition' label-width='80px' :model='roleData'>
        <el-form-item label='角色名称'>
          <el-input t v-model='roleData.role_name' placeholder='请输入角色名称'></el-input>
        </el-form-item>

        <el-row :gutter='24'>
          <el-col :span='6'>
            <el-form-item label='查询权限'>
              <el-tree
                :data='query'
                show-checkbox
                ref='query'
                highlight-current
                node-key='id'
                :props='defaultProps'>
              </el-tree>
            </el-form-item>
          </el-col>
          <el-col :span='6' :offset='2'>
            <el-form-item label='设置权限'>
              <el-tree
                :data='control'
                show-checkbox
                ref='control'
                highlight-current
                node-key='id'
                :props='defaultProps'>
              </el-tree>
            </el-form-item>
          </el-col>
          <el-col :span='6' :offset='2'>
            <el-form-item label='其他权限'>
              <el-tree
                :data='other'
                show-checkbox
                ref='other'
                highlight-current
                node-key='id'
                :props='defaultProps'>
              </el-tree>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='dialogVisible = false'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='handleSumbitClick'>确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { gateway } from '@/api/admin.js'
import ElContainer from '../../../node_modules/element-ui/packages/container/src/main.vue'

export default {
  components: { ElContainer },
  data() {
    return {
      Tip: '',
      tableData: [],
      loading: false,
      labelPosition: 'center',
      dialogVisible: false,
      roleData: {
        id: '',
        role_name: '',
        get_permission_value: 0,
        set_permission_value: 0,
        other_permission_value: 0
      },
      isEdit: false,
      queryLists: [],
      controlLists: [],
      otherLists: [],
      query: [],
      control: [],
      other: [],
      defaultProps: {
        label: 'label'
      }
    }
  },

  created() {
    this.getRole()
    this.getPermission()
  },

  methods: {

    getRole() {
      this.loading = true

      let str = JSON.stringify({
        role_id: 0
      })
      gateway({
        func: 'get_agency_role',
        page_no: 1,        page_size: 10,
        params: str
      }).then(res => {
        this.loading = false
        this.tableData = res.result
      })
    },
    getPermission() {
      this.query = []
      this.control = []
      this.other = []
      gateway({
        func: 'get_permission',
        params: JSON.stringify({})
      }).then(res => {

        var getList = []
        var setList = []
        var otherList = []

        res.result.forEach((v) => {

          if (v.permission_type == 'GET') {
            getList.push(v)
          }
          if (v.permission_type == 'SET') {
            setList.push(v)
          }

          if (v.permission_type == 'OTHER') {
            otherList.push(v)
          }
        })

        this.queryLists = getList
        this.controlLists = setList
        this.otherLists = otherList

        this.query = this.setListData(this.queryLists)
        this.control = this.setListData(this.controlLists)
        this.other = this.setListData(this.otherLists)
      })
    },

    setListData(data) {
      var ListsData = []
      data.forEach((v) => {
        var isFlag = false
        ListsData.forEach((n) => {
          if (n.permission_type == v.permission_type) {
            isFlag = true
          }
        })
        if (!isFlag) {
          var d = {}
          d['id'] = v.permission_value
          d['type'] = v.permission_type
          d['label'] = v.permission_explain
          d['children'] = []
          ListsData.push(d)
        }
      })
      data.forEach((v) => {
        ListsData.forEach((n) => {
          if (v.permission_value == n.permission_explain) {
            var d = {}
            d['id'] = v.permission_value
            d['type'] = v.permission_type
            d['label'] = v.permission_explain
            n.children.push(d)
          }
        })
      })
      return ListsData
    },
    handleAddClick() {
      this.Tip = '新增角色'
      this.isEdit = false
      this.dialogVisible = true
      this.roleData = {
        id: '',
        role_name: '',
        get_permission_value: 0,
        set_permission_value: 0,
        other_permission_value: 0
      }
      this.clear()
    },

    handleDeleteClick(row) {

      this.$confirm('是否删除角色：' + row.role_name + ' ？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'del_agency_role',
          params: str
        }).then(() => {
          this.getRole()
        })

      }).catch(() => {

      })
    },

    handleSettingClick(row) {
      this.Tip = '设置角色'
      this.isEdit = true
      this.dialogVisible = true
      this.roleData = {
        id: row.id,
        role_name: row.role_name,
        get_permission_value: row.get_permission_value,
        set_permission_value: row.set_permission_value,
        other_permission_value: row.other_permission_value
      }

      console.log('get_permission_value:', row.get_permission_value)
      // console.log(row.set_permission_value)
      // console.log(row.other_permission_value)

      this.clear()
      var querySelectLists = []
      var controlSelectLists = []
      var otherSelectLists = []

      this.queryLists.forEach((v) => {
        var count = row.get_permission_value & v.permission_value
        if (count == v.permission_value) {
          querySelectLists.push(v.permission_value)
          this.$nextTick(() => {
            this.$refs.query.setCheckedKeys(querySelectLists)
          })
        }
      })

      this.controlLists.forEach((v) => {
        var count = row.set_permission_value & v.permission_value
        if (count == v.permission_value) {
          controlSelectLists.push(v.permission_value)
          this.$nextTick(() => {
            this.$refs.control.setCheckedKeys(controlSelectLists)
          })
        }
      })

      this.otherLists.forEach((v) => {
        var count = row.other_permission_value & v.permission_value
        if (count == v.permission_value) {
          otherSelectLists.push(v.permission_value)
          this.$nextTick(() => {
            this.$refs.other.setCheckedKeys(otherSelectLists)
          })
        }
      })
      if (controlSelectLists.length == 0) {
        this.$nextTick(() => {
          this.$refs.control.setCheckedKeys([])
        })
      } else if (querySelectLists.length == 0) {
        this.$nextTick(() => {
          this.$refs.query.setCheckedKeys([])
        })
      } else if (otherSelectLists.length == 0) {
        this.$refs.other.setCheckedKeys([])
      }
    },
    clear() {
      this.$nextTick(() => {
        this.$refs.query.setCheckedKeys([])
        this.$refs.control.setCheckedKeys([])
        this.$refs.other.setCheckedKeys([])
      })
    },
    handleSumbitClick: function() {

      this.$nextTick(() => {
        var params = {}

        //查询权限
        var queryData = this.$refs.query.getCheckedNodes()

        var query_permission = 0
        queryData.forEach((v) => {
          console.log('permission_value:', v.id)
          query_permission = query_permission | v.id
        })
        this.roleData.get_permission_value = query_permission


        //设置权限
        var controlData = this.$refs.control.getCheckedNodes()
        var control_permission = 0
        controlData.forEach((v) => {
          control_permission = control_permission | v.id
        })
        this.roleData.set_permission_value = control_permission


        //其他权限
        var otherData = this.$refs.other.getCheckedNodes()
        var other_permission = 0
        otherData.forEach((v) => {
          other_permission = other_permission | v.id
        })
        this.roleData.other_permission_value = other_permission


        if (this.isEdit) {
          let str = JSON.stringify(this.roleData)
          params = str
        } else {
          let str = JSON.stringify({
            role_name: this.roleData.role_name,
            get_permission_value: this.roleData.get_permission_value,
            set_permission_value: this.roleData.set_permission_value,
            other_permission_value: this.roleData.other_permission_value
          })
          params = str
        }
        if (this.roleData.role_name == '') {
          this.$message.warning('请输入角色名称')
          return
        }
        gateway({
          func: this.isEdit == true ? 'set_agency_role' : 'create_agency_role',
          params: params
        }).then(res => {
          if (res.code === 0) {
            this.dialogVisible = false
            if (this.isEdit) {
              this.$message.success('设置角色成功')
            } else {
              this.$message.success('新增角色成功')
            }
            this.clear()
            this.getRole()
          } else {
            this.$message.warning(res.msg)
          }
        })
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.el-tree-node__label {
  font-size: 13px;
  padding-left: 10px;
}

.page {
  text-align: center;
  font-size: 13px;
  color: #606266;
  padding-top: 20px;
}

.foor {
  border-top: 1px solid #eee;
}


/* 选中某行时的背景色*/
///deep/  .el-table__body tr.current-row > td {
//  background-color: #C0C4CC !important;
//}
/*鼠标移入某行时的背景色*/
/deep/  .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #C0C4CC;
}


</style>
